import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
import cx from 'classnames';
import pageTypes from 'utils/pageTypes';
import breakpoints from 'utils/breakpoints';
import { colors } from 'utils/tailwindColors';
import { Heading, Copy } from 'components/components/atoms';
import { isValidTitle } from 'utils/validateTitle';

const FormsTitleContainer = styled.div`
  max-width: 53.75rem;
`;
const RequiredCopy = styled(Copy)`
  ${({ signUpForUpdatesStyle }) =>
    signUpForUpdatesStyle ? 'font-size: 0.813rem;' : ''};
  ${({ signUpForUpdatesStyle }) =>
    signUpForUpdatesStyle ? `color: ${colors['mattamy-search-gray']};` : ''};
`;
const Divider = styled.hr`
  border-top: 1px solid #e0e4ea;
  margin: 0 0 20px;
`;
const HeadingContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 35rem;
  }
`;

const CopyContainer = styled.div`
  @media ${breakpoints.lg} {
    max-width: 45rem;
  }
`;

const FormsTitle = ({
  fields,
  hasNoSectionsLeft = false,
  signUpForUpdatesStyle = false,
}) => {
  const title = getFieldValue(fields, 'title');
  const description = getFieldValue(fields, 'description');
  const currentPageType = getFieldValue(fields, 'currentPageType');

  return (
    <FormsTitleContainer
      className={cx('flex flex-col w-full text-mattamy-blue', {
        'justify-center items-center':
          !signUpForUpdatesStyle &&
          (currentPageType === pageTypes.MarketPage ||
            currentPageType === pageTypes.SupportPage ||
            hasNoSectionsLeft),
        'justify-left': !currentPageType === pageTypes.MarketPage,
        'justify-left items-left': signUpForUpdatesStyle,
      })}
    >
      {(currentPageType === pageTypes.MarketPage || title) &&
        isValidTitle(title) && (
          <h3
            className={cx('font-trade-gothic-20 text-3xl mb-1', {
              'md:mb-3': !signUpForUpdatesStyle,
            })}
          >
            {title}
          </h3>
        )}
      {currentPageType === pageTypes.SupportPage && (
        <>
          <HeadingContainer>
            <Heading as='h2' className='lg:my-1'>
              {title}
            </Heading>
          </HeadingContainer>
          <CopyContainer>
            <Copy className='leading-relaxed'>{description}</Copy>
          </CopyContainer>
        </>
      )}
      <CopyContainer>
        <RequiredCopy
          className='leading-relaxed'
          signUpForUpdatesStyle={signUpForUpdatesStyle}
        >
          {'Required fields are marked with *'}
        </RequiredCopy>
      </CopyContainer>
      {signUpForUpdatesStyle && <Divider className=' ' />}
    </FormsTitleContainer>
  );
};

export default FormsTitle;
